class SampleBuilder {
  constructor() {
    this.SAMPLE_SET_VARIANT_ID = '47198793040099'; // Sample set variant ID
    this.MAX_SAMPLES = 5;
    this.selectedSamples = JSON.parse(localStorage.getItem('selectedSamples')) || [];

    this.init();
  }

  /* -----------------------------
      INITIALIZATION
  ------------------------------*/
  init() {
    this.setupSampleButtons();
    this.setupCartButtons();
    this.setupStickyBar();
    this.setupMobileModal();
    this.restoreSavedSelections();
  }
  

  /* -----------------------------
      SAMPLE SELECTION LOGIC
  ------------------------------*/
  setupSampleButtons() {
    document.querySelectorAll('.sample-select-btn').forEach(btn => {
      btn.addEventListener('click', e => this.handleSampleSelect(e));
    });
  }

  handleSampleSelect(e) {
    const btn = e.target.closest('.sample-select-btn');
    if (!btn) return;

    const productId = btn.dataset.productId;
    const productTitle = btn.dataset.productTitle;
    const productImage = btn.dataset.productImage;

    const existingIndex = this.selectedSamples.findIndex(s => s.id === productId);

    if (existingIndex > -1) {
      this.selectedSamples.splice(existingIndex, 1);
      btn.classList.remove('selected');
      btn.querySelector('.select-text').style.display = 'inline';
      btn.querySelector('.selected-text').style.display = 'none';
    } else {
      if (this.selectedSamples.length >= this.MAX_SAMPLES) {
        alert(`You can only select ${this.MAX_SAMPLES} samples.`);
        return;
      }

      this.selectedSamples.push({
        id: productId,
        title: productTitle,
        image: productImage
      });

      btn.classList.add('selected');
      btn.querySelector('.select-text').style.display = 'none';
      btn.querySelector('.selected-text').style.display = 'inline';
    }

    this.saveSelections();
    this.updateUI();
  }

  saveSelections() {
    localStorage.setItem('selectedSamples', JSON.stringify(this.selectedSamples));
  }

  restoreSavedSelections() {
    this.selectedSamples.forEach(sample => {
      const btn = document.querySelector(`.sample-select-btn[data-product-id="${sample.id}"]`);
      if (btn) {
        btn.classList.add('selected');
        btn.querySelector('.select-text').style.display = 'none';
        btn.querySelector('.selected-text').style.display = 'inline';
      }
    });

    this.updateUI();
  }

  /* -----------------------------
      UI UPDATE (SLOTS + BUTTONS)
  ------------------------------*/
  updateUI() {
    this.updateSlots('sample-slots');
    this.updateSlots('mobile-slots');
    this.updateSlots('sticky-slots');
    this.updateStickySlots();
    this.updateButtons();
    this.updateMobileBadge();
  }

  updateSlots(containerId) {
    const container = document.getElementById(containerId);
    if (!container) return;

    const slots = container.querySelectorAll('[data-slot-index]');

    slots.forEach((slot, index) => {
      const placeholderIcon = slot.querySelector('.placeholder-icon');
      const productImage = slot.querySelector('.slot-product-image');
      const slotTitle = slot.querySelector('.sample-slot-title, .mobile-slot-title, .sticky-slot-title');
      const removeBtn = slot.querySelector('.slot-remove-btn');

      if (this.selectedSamples[index]) {
        const sample = this.selectedSamples[index];
        
        // Truncate title for sticky bar - show only PP# portion
        let displayTitle = sample.title;
        if (containerId === 'sticky-slots' && sample.title.includes(' - ')) {
          displayTitle = sample.title.split(' - ')[0].trim();
        }

        if (placeholderIcon) placeholderIcon.style.display = 'none';
        if (productImage) {
          productImage.src = sample.image;
          productImage.style.display = 'block';
        }
        if (slotTitle) slotTitle.textContent = displayTitle;
        if (removeBtn) {
          removeBtn.style.display = 'block';
          removeBtn.onclick = () => this.removeSample(sample.id);
        }
      } else {
        if (placeholderIcon) placeholderIcon.style.display = 'block';
        if (productImage) productImage.style.display = 'none';
        if (slotTitle) slotTitle.textContent = '';
        if (removeBtn) removeBtn.style.display = 'none';
      }
    });
  }

  updateStickySlots() {
    const container = document.querySelector('.sticky-slots-mini');
    if (!container) return;

    container.querySelectorAll('.sticky-slot-mini').forEach((slot, index) => {
      const placeholderIcon = slot.querySelector('.placeholder-icon');
      const productImage = slot.querySelector('.slot-product-image');
      const removeBtn = slot.querySelector('.slot-remove-btn');

      if (this.selectedSamples[index]) {
        if (placeholderIcon) placeholderIcon.style.display = 'none';
        if (productImage) {
          productImage.src = this.selectedSamples[index].image;
          productImage.style.display = 'block';
        }
        // Add remove functionality to mini slots
        if (removeBtn) {
          removeBtn.style.display = 'block';
          removeBtn.onclick = () => this.removeSample(this.selectedSamples[index].id);
        }
      } else {
        if (placeholderIcon) placeholderIcon.style.display = 'block';
        if (productImage) productImage.style.display = 'none';
        if (removeBtn) removeBtn.style.display = 'none';
      }
    });

    const stickyCount = document.getElementById('sticky-count');
    if (stickyCount) stickyCount.textContent = this.selectedSamples.length;
  }

  updateButtons() {
    const isComplete = this.selectedSamples.length === this.MAX_SAMPLES;

    ['add-sample-set', 'sticky-add-cart', 'mobile-add-cart'].forEach(id => {
      const btn = document.getElementById(id);
      if (btn) btn.disabled = !isComplete;
    });

    document.querySelectorAll('.sample-select-btn').forEach(btn => {
      const productId = btn.dataset.productId;
      const isSelected = this.selectedSamples.find(s => s.id === productId);

      if (!isSelected && this.selectedSamples.length >= this.MAX_SAMPLES) {
        btn.disabled = true;
        btn.querySelector('.select-text').textContent = 'Selection Full';
      } else if (!isSelected) {
        btn.disabled = false;
        btn.querySelector('.select-text').textContent = 'Add 5ml Sample';
      }
    });
  }

  updateMobileBadge() {
    const badge = document.getElementById('mobile-badge');
    if (badge) badge.textContent = this.selectedSamples.length;
  }

  removeSample(productId) {
    const btn = document.querySelector(`.sample-select-btn[data-product-id="${productId}"]`);
    if (btn) btn.click();
  }

  /* -----------------------------
      CART BUTTON SETUP
  ------------------------------*/
  setupCartButtons() {
    ['add-sample-set', 'sticky-add-cart', 'mobile-add-cart'].forEach(id => {
      const btn = document.getElementById(id);
      if (btn) btn.addEventListener('click', () => this.handleAddToCart());
    });
  }

  /* -----------------------------
      CART DRAWER FORCE REFRESH
  ------------------------------*/
  async forceRefreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();

      const parser = new DOMParser();
      const doc = parser.parseFromString(data['cart-drawer'], 'text/html');

      const newDrawer = doc.querySelector('cart-drawer');
      const oldDrawer = document.querySelector('cart-drawer');

      if (newDrawer && oldDrawer) {
        oldDrawer.innerHTML = newDrawer.innerHTML;
      }

      if (window.updateCartShippingBar) {
        window.updateCartShippingBar();
      }

      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active') === false) {
        drawer.classList.add('active');
      }
    } catch (err) {
      console.error('Cart drawer refresh failed:', err);
    }
  }

  /* -----------------------------
      ADD TO CART LOGIC
  ------------------------------*/
  async handleAddToCart() {
    if (this.selectedSamples.length !== this.MAX_SAMPLES) return;

    const buttons = ['add-sample-set', 'sticky-add-cart', 'mobile-add-cart'];
    buttons.forEach(id => {
      const btn = document.getElementById(id);
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Adding...';
      }
    });

    try {
      const ppNumbers = this.selectedSamples
        .map(s => s.title.split(' - ')[0].trim())
        .join(', ');

      // ADD PRODUCT TO CART
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: this.SAMPLE_SET_VARIANT_ID,
          quantity: 1,
          properties: { 'Selected Samples': ppNumbers }
        })
      });

      if (!response.ok) throw new Error('Add to cart failed');

      // ⭐ Refresh drawer content
      await this.forceRefreshCartDrawer();

      // Update cart count bubble
      const cartData = await fetch('/cart.js').then(r => r.json());
      document.querySelectorAll('.cart-count-bubble span').forEach(el => {
        el.textContent = cartData.item_count;
      });

      // Clear selections
      localStorage.removeItem('selectedSamples');
      this.selectedSamples = [];
      this.updateUI();

      // FULL reset of product card buttons
      document.querySelectorAll('.sample-select-btn').forEach(btn => {
        btn.classList.remove('selected');
        btn.disabled = false;
        const selectText = btn.querySelector('.select-text');
        const selectedText = btn.querySelector('.selected-text');
        if (selectText) selectText.style.display = 'inline';
        if (selectedText) selectedText.style.display = 'none';
      });

      // Close mobile modal if open
      const modal = document.getElementById('mobile-modal');
      if (modal) {
        modal.classList.remove('show');
        document.body.style.overflow = '';
      }

      // Open drawer
      const drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.open) drawer.open();

    } catch (err) {
      console.error(err);
      alert('Error adding to cart. Please try again.');
    }

    // Reset buttons
    buttons.forEach(id => {
      const btn = document.getElementById(id);
      if (btn) {
        btn.disabled = true;
        btn.textContent = 'Add to Cart';
      }
    });
  }

  /* -----------------------------
      STICKY BAR
  ------------------------------*/
  setupStickyBar() {
    const selectionHeader = document.getElementById('selection-header');
    const stickyBar = document.getElementById('sticky-bar');

    if (!selectionHeader || !stickyBar) return;

    const updateStickyBar = () => {
      const headerBottom = selectionHeader.offsetTop + selectionHeader.offsetHeight;
      const scrollTop = window.pageYOffset;

      if (window.innerWidth > 900) {
        if (scrollTop > headerBottom + 100) {
          stickyBar.style.display = 'block';
          requestAnimationFrame(() => stickyBar.classList.add('show'));
        } else {
          stickyBar.classList.remove('show');
          setTimeout(() => {
            if (!stickyBar.classList.contains('show')) {
              stickyBar.style.display = 'none';
            }
          }, 300);
        }
      } else {
        stickyBar.style.display = 'none';
        stickyBar.classList.remove('show');
      }
    };

    window.addEventListener('scroll', updateStickyBar);
    window.addEventListener('resize', updateStickyBar);

    setTimeout(updateStickyBar, 100);
  }

  /* -----------------------------
      MOBILE MODAL
  ------------------------------*/
  setupMobileModal() {
    const floatBtn = document.getElementById('mobile-float');
    const modal = document.getElementById('mobile-modal');
    const closeBtn = document.getElementById('modal-close');
    const overlay = modal?.querySelector('.mobile-modal-overlay');

    if (floatBtn && modal) {
      floatBtn.addEventListener('click', () => {
        modal.classList.add('show');
        document.body.style.overflow = 'hidden';
      });
    }

    if (closeBtn && modal) {
      closeBtn.addEventListener('click', () => {
        modal.classList.remove('show');
        document.body.style.overflow = '';
      });
    }

    if (overlay && modal) {
      overlay.addEventListener('click', () => {
        modal.classList.remove('show');
        document.body.style.overflow = '';
      });
    }
  }
}

/* -----------------------------
  INIT
------------------------------*/
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    window.sampleBuilderInstance = new SampleBuilder();
  });
} else {
  window.sampleBuilderInstance = new SampleBuilder();
}